import axios from "axios";
import React, { createContext, useState, useEffect } from "react";

export const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [profile, setProfile] = useState();
  const [selectedProjectId, setSelectedProjectId] = useState(
    localStorage.getItem("project_id") || ""
  );
  const [role, setRole] = useState(localStorage.getItem("role") || "");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(
          " https://eutracker.rdiup.com/v1/user/getProfile/",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        console.log("profile in context", response.data.user);

        setProfile(response.data.user);
        localStorage.setItem("is_admin", response.data.user.is_admin);
      } catch (err) {
        console.log("Failed to fetch profile");
      }
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(
          " https://eutracker.rdiup.com/v1/projects/"
        );
        const data = response.data;
        console.log("all projects in context", response.data);

        const storedOrganisationName = Number(
          localStorage.getItem("organisation_name")
        );

        const filteredProjects = data.filter((project) => {
          const isCoordinator =
            project.coordinator &&
            project.coordinator === storedOrganisationName;
          const isMember =
            Array.isArray(project.members_details) &&
            project.members_details.some(
              (detail) => detail.id === storedOrganisationName
            );
          const isModerator =
            project.moderator && project.moderator === storedOrganisationName;

          return isCoordinator || isMember || isModerator;
        });

        // Update state with filtered projects or all projects if the user is an admin
        if (profile && profile.is_admin === false) {
          setProjects(filteredProjects);
          if (filteredProjects.length > 0 && !selectedProjectId) {
            setSelectedProjectId(filteredProjects[0].id);
            handleProjectChange({ target: { value: filteredProjects[0].id } }); // Automatically select the first project
            // window.location.href = "/projects";
          }
        }
        if (profile && profile.is_admin === true) {
          setProjects(data);
          if (data.length > 0 && !selectedProjectId) {
            handleProjectChange({ target: { value: data[0].id } });
          }
        }
      } catch (error) {
        console.error(
          "Error fetching projects:",
          error.response ? error.response.data : error.message
        );
      }
    };

    fetchProjects();
  }, [profile, selectedProjectId]);

  const handleProjectChange = (event) => {
    const selectedId = event.target.value;
    const selectedProject = projects.find(
      (project) => project.id === Number(selectedId)
    );

    if (selectedProject) {
      const storedOrganisationName = Number(
        localStorage.getItem("organisation_name")
      );

      localStorage.setItem("logo", selectedProject.imageURL);

      let userRole = "none";

      if (
        selectedProject.coordinator &&
        selectedProject.coordinator === storedOrganisationName
      ) {
        userRole = "coordinator";
        setRole("coordinator");
      }

      if (selectedProject.members_details) {
        const memberNames = selectedProject.members_details.map(
          (detail) => detail.id
        );

        if (memberNames.includes(storedOrganisationName)) {
          userRole = "member";
          setRole("member");
        }
      }

      if (
        selectedProject.moderator &&
        selectedProject.moderator === storedOrganisationName
      ) {
        userRole = "moderator";
        setRole("moderator");
      }

      if (
        selectedProject.moderator_details &&
        selectedProject.coordinator_details
      ) {
        const moderatorNames = Array.isArray(selectedProject.moderator_details)
          ? selectedProject.moderator_details.map((detail) =>
              detail.name.toLowerCase()
            )
          : [selectedProject.moderator_details.name.toLowerCase()];

        const coordinatorNames = Array.isArray(
          selectedProject.coordinator_details
        )
          ? selectedProject.coordinator_details.map((detail) =>
              detail.name.toLowerCase()
            )
          : [selectedProject.coordinator_details.name.toLowerCase()];

        if (
          moderatorNames.includes(storedOrganisationName) &&
          coordinatorNames.includes(storedOrganisationName)
        ) {
          userRole = "coordinator";
          setRole("coordinator");
        }
      }

      // window.location.href = "/";

      localStorage.setItem("project_id", selectedProject.id);
      localStorage.setItem("project_name", selectedProject.name);
      localStorage.setItem("role", userRole);
      localStorage.setItem("project_color", selectedProject.color);
      setSelectedProjectId(selectedProject.id);
    } else {
      localStorage.removeItem("project_id");
      localStorage.removeItem("role");
      setSelectedProjectId("");
    }
  };

  return (
    <ProjectContext.Provider
      value={{
        projects,
        profile,
        setProfile,
        setProjects,
        selectedProjectId,
        setSelectedProjectId,
        setRole,
        role,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};
